/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description <p>Возможные значения:</p>\n<ul>\n<li><b>1 - Music</b>: Музыка</li>\n<li><b>2 - Podcast</b>: Подкаст</li>\n<li><b>3 - Sermon</b>: Проповедь</li>\n<li><b>4 - Book</b>: Аудиокнига</li>\n<li><b>5 - Jingle</b>: Джингл</li>\n</ul>\n
 */
export const trackTypeEnumSchema = z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4), z.literal(5)]).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Music</b>: Музыка</li>\n<li><b>2 - Podcast</b>: Подкаст</li>\n<li><b>3 - Sermon</b>: Проповедь</li>\n<li><b>4 - Book</b>: Аудиокнига</li>\n<li><b>5 - Jingle</b>: Джингл</li>\n</ul>\n")